import { render, staticRenderFns } from "./ToolsNavbarSidebar.vue?vue&type=template&id=06dd7b86"
import script from "./ToolsNavbarSidebar.vue?vue&type=script&lang=js"
export * from "./ToolsNavbarSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports